module.exports = __webpack_public_path__ + "media/components/wind-icon/static/SW@2x-44c06bb4c6689128be9dfcd3ba281ef6.png";